export enum ComparePageObjectModel {
  CompareSidebar = 'compare-sidebar',
  ComparisonViewer = '3D Model Comparison Viewer',
  ErrorMessage = 'error-message',
  GeometricMatchScore = 'geometric-match-score',
  VolumetricMatchScore = 'volumetric-match-score',
  LoadingIndicator = 'loading-indicator',
  ZeroStateContainer = 'zero-state-container',
  TextDiff = 'text-diff',
  TextDiffMessage = 'text-diff-message',
  TextDiffSummary = 'text-diff-summary',
  TextDiffSplitView = 'text-diff-split-view',
  TextDiffUnifiedView = 'text-diff-unified-view',
  TextDiffCollapsedLines = 'text-diff-collapsed-lines',
}
